import useNetwork from '@/hooks/use-network';
import { createContext } from 'react';
import TransactionWarehouseProvider from './transaction-warehouse-provider';

export const WarehouseContext = createContext<{
  networkStatus: boolean;
}>({
  networkStatus: true,
});

export default function WarehouseProvider(props: {
  children?: React.ReactNode;
}) {
  const { isOnline } = useNetwork();

  return (
    <WarehouseContext.Provider
      value={{
        networkStatus: isOnline,
      }}
    >
      <TransactionWarehouseProvider>
        {props.children}
      </TransactionWarehouseProvider>
    </WarehouseContext.Provider>
  );
}
